import { Component, OnDestroy, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { InventoryStockTakeDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/InventoryStockTake/inventory-stock-take-dto';
import { InventoryService } from 'src/api/generated/services';
import { ActivatedRoute, Router } from '@angular/router';
import { CurrentVenueHelperService } from 'src/app/share-modul/services/current-venue-helper/current-venue.helper.service';
import { GetInventoryStockTake$Params } from 'src/api/generated/fn/inventory/get-inventory-stock-take';
import { InventoryActionStatus } from 'src/app/pos-panel/enums/inventory-action-status.enum';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { CancelInventoryStockTake$Params } from 'src/api/generated/fn/inventory/cancel-inventory-stock-take';
import { Subscription } from 'rxjs';
import { GetInventory$Params } from 'src/api/generated/fn/inventory/get-inventory';
import { InventoryDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Inventory/inventory-dto';

@Component({
  selector: 'app-stock-take-details',
  templateUrl: './stock-take-details.component.html',
  styleUrls: ['./stock-take-details.component.scss']
})
export class StockTakeDetailsComponent implements OnInit, OnDestroy {

  venueId: string;
  inventoryId: string;
  stockTakeId: string;
  inventory: InventoryDto;

  stockTake: InventoryStockTakeDto = {} as InventoryStockTakeDto;
  InventoryActionStatus = InventoryActionStatus;
  venueIdUpdateSubscription: Subscription;
  timezoneOffset: any;

  constructor(
              private inventoryService: InventoryService,
              private router: Router,
              private route: ActivatedRoute,
              private currentVenueHelper: CurrentVenueHelperService,
              private confirmationService: ConfirmationService, 
              public translate: TranslateService,
              private messageService: MessageService) {

   }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params['venue-id'] != null) {
        this.venueId = params['venue-id'];
        this.currentVenueHelper.updateCurrentVenueIdDropdown(params['venue-id']);
        this.currentVenueHelper.getTimezone().subscribe(tzOffset => this.timezoneOffset = tzOffset);
      }
      if (params['inventory-id'] != null && params['stock-take-id'] != null) {
        this.inventoryId = params['inventory-id'];
        this.stockTakeId = params['stock-take-id'];

        const paramsStockTake: GetInventoryStockTake$Params = { inventoryId: this.inventoryId, stockTakeId: this.stockTakeId }
        this.inventoryService.getInventoryStockTake(paramsStockTake).subscribe( response =>  this.stockTake = response );
        
        const inventoryParams: GetInventory$Params = { inventoryId: this.inventoryId };
        this.inventoryService.getInventory(inventoryParams).subscribe(response => this.inventory = response);
      }
    });

  }
  cancelStockTake(){
    this.confirmationService.confirm({
      header: this.translate.instant('STOCK_TAKE.CONFIRMATION_DIALOG_CANCEL_STOCK_TAKE_TITLE'),
      message: this.translate.instant('STOCK_TAKE.CONFIRMATION_DIALOG_CANCEL_STOCK_TAKE_QUESTION'),
      acceptLabel: this.translate.instant('YES'),
      rejectLabel: this.translate.instant('NO'),
      defaultFocus: "reject",
      acceptButtonStyleClass: 'soc-confirmation-dialog dialog-btn destructive-btn',
      rejectButtonStyleClass: 'soc-confirmation-dialog dialog-btn reject-btn',
      accept: () => {
        const params: CancelInventoryStockTake$Params = { inventoryId: this.inventoryId, stockTakeId: this.stockTakeId };
        this.inventoryService.cancelInventoryStockTake(params).subscribe({
            next: response => {
              this.messageService.add( { severity: 'success', summary: 'Stock take was successfully cancelled!', life: 3000 } );
              this.navigateToMain();
            },
            error: errorResponse => this.messageService.add( { severity: 'error', summary: 'Error occurred!', life: 3000 } )
      })  
      }
    });

  }
 
  navigateToMain() {
    if(this.inventory.isMain){
      this.router.navigate([this.venueId, "inventory", this.inventoryId], { queryParams: { activeIndex: 4 }}); 
    }else{
      this.router.navigate([this.venueId, "inventory", this.inventoryId], { queryParams: { activeIndex: 3 }}); 
    }
  }

  public ngOnDestroy(): void {
    if (this.venueIdUpdateSubscription) {
      this.venueIdUpdateSubscription.unsubscribe();
    }
  }
}
